import integration from "./integration"
import driver from "./driver"
import truck from "./truck";
import { getEldIcons, getLastUpdateTime, getCarrierList } from "@/api/eldv2";
import Vue from "vue";
import { systemInfo } from '@/shared-services'

export default {
  namespaced: true,
  state: {
    icons: {},
    updateTimeLoading: false,
    connectedUpdateTime: null,
    driverToConnectUpdateTime: null,
    truckToConnectUpdateTime: null,
    carrierList: [],
    carrierCheck: '',
    getCarrrier: false
  },
  mutations: {
    SET_ICONS(state, payload) {
      state.icons = payload || {};
    },
    SET_CARRIERLIST(state, payload) {
      state.carrierList = payload || [];
    }, 
    SET_GETCARRIER(state, payload) {
      state.getCarrrier = payload;
    },
    SET_CARRIERCHECK(state, payload) {
      state.carrierCheck = payload;
    },
    SET_CONNECTEDUPDATETIME(state, date) {
      state.connectedUpdateTime = date;
    },
    SET_DRIVERUPDATETIME(state, date) {
      state.driverToConnectUpdateTime = date;
    },
    SET_TRUCKUPDATETIME(state, date) {
      state.truckToConnectUpdateTime = date;
    },
    SET_UPDATETIMELOADING(state, loading) {
      state.updateTimeLoading = loading;
    },
  },
  actions: {
    setCarrier({ commit }, data) {
      commit('SET_CARRIERCHECK', data)
    },
    getCarrierList ({ commit, dispatch, state }) {
      if (systemInfo.isCommand) {
        commit('SET_GETCARRIER', true)
        return Promise.resolve()
      }
      return getCarrierList().then( (res) => {
        commit('SET_GETCARRIER', true)
        res.res.data.data && res.res.data.data.forEach(item => {
          item.value = item.fleetCompanyId
          item.label = item.companyName
        });
        const list = res.res.data.data || []
        commit('SET_CARRIERLIST', list)
        const fleetCompanyId = state.carrierCheck
        const index = list.findIndex(res => res.fleetCompanyId == fleetCompanyId)
        if (fleetCompanyId && index == -1) {
          dispatch('setCarrier', res.res.data.data[0].fleetCompanyId)
        }
        if(res.res.data.data && res.res.data.data[0] && !fleetCompanyId) {
          dispatch('setCarrier', res.res.data.data[0].fleetCompanyId)
        }
        console.log(res, 'carrier')
      })
    },
    async getIcon({ commit }) {
      getEldIcons().then(({ res }) => {
        const data = res.data.data;
        let obj = data
        if (Array.isArray(data)) {
          obj = {}
          data.forEach(item => {
            obj[item.integrationSource] = item.icon
          }) 
        }
        commit('SET_ICONS', obj);
      });
    },
    async getLastUpdateTime({ commit, state }, type) {
      const fleetCompanyId = state.carrierCheck
      if (!systemInfo.isCommand && !fleetCompanyId) {
        return
      }
      commit('SET_UPDATETIMELOADING', true);
      await getLastUpdateTime(type, fleetCompanyId).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          return;
        }
        let commitMutation = '';
        switch(type) {
          case "driver":
            commitMutation = 'SET_DRIVERUPDATETIME';
            break;
          case "truck":
            commitMutation = 'SET_TRUCKUPDATETIME';
            break;
          case "location":
            commitMutation = 'SET_CONNECTEDUPDATETIME';
            break;
        }
        commit(commitMutation, data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
      }).finally(() => {
        commit('SET_UPDATETIMELOADING', false);
      });
    }
  },
  modules: {
    integration,
    driver,
    truck,
  },
  getters: {
    carrierList: (state) => state.carrierList,
    carrierCheck: (state) => state.carrierCheck,
    getCarrrier: (state) => state.getCarrrier,
  }
}
